<template lang="html">
  <header :class="{active: isActive}">
    <div class="logo-wrap">
      <div class="title">{{$t(title)}}</div>
      <router-link to="/index" class="logo">
        <img src="@/assets/header-logo.png" alt="">
      </router-link>
      <div class="menu-button" :class="{active: isActive}" @click="openNav"><div class="bar"></div> <div class="bar"></div> <div class="bar"></div></div>
    </div>
    <div class="nav-wrap" :class="{'en':lang==='en','zh':lang==='zh'}" @click="isActive=false">

      <ul class="nav">
        <li v-for="(item,index) in showRouter" :key="index">

          <div v-if="item.children.length>1"  class="a" @click.stop="openSubmenu(index)" :class="{show:subNavShowIndex===index}">
            {{$t(item.meta?item.meta.key : item.children[0].meta.key)}}<i class="el-icon-d-arrow-right"></i>
            <!-- {{item.meta.title}}<i class="el-icon-d-arrow-right"></i> -->
          </div>
          <router-link class="a" v-if="item.children.length==1" :to="item.children[0].meta.path">
              <!-- {{item.children[0].meta.title}} -->
              {{$t(item.meta?item.meta.key : item.children[0].meta.key)}}
          </router-link>

          <a v-if="index===3" class="a" href="https://reg.uniceramics.com.cn/live2023/playback.html" target="_bland">
              <span>2023 Live Playback</span>
          </a>
          <a v-if="index===3" class="a" href="http://www.uniceramics.com.cn/live/playback2021.php" target="_bland">
              <span>2021 Live Playback</span>
          </a>
          <a v-if="index===3" class="a" href="http://www.uniceramics.com.cn/live/playback.php" target="_bland">
              <span>2020 Live Playback</span>
          </a>

          <ul class="sub-nav" :class="{hide:subNavShowIndex!==index}" v-if="item.children.length>1" :style="{height:subMenuLength(item.children)*45+'px'}">
            <li class="sub-nav-item" v-for="(subItem,index) in item.children" :key="index" v-if="!subItem.hidden">
              <router-link v-if="!subItem.meta.disabled" class="a" :to='subItem.meta.path'>{{$t(subItem.meta.key)}}</router-link>
              <div v-if="subItem.meta.disabled" class="a disabled" @click="tips">{{$t(subItem.meta.key)}}</div>
            </li>
          </ul>
        </li>

        <!-- <li>
          <router-link class="a" to="/seller">参展商与产品</router-link>
        </li> -->

       <!--  <li>
          <a class="a" href="http://www.uniceramics.com.cn/live/playback.php" target="_bland">
              <span>直播精彩回放</span>
          </a>
        </li> -->

        <!-- <li class="i18n">
          <a class="a" target="_bland" href="https://www.uniceramicsexpo.com/subscribe/index.html">
            <span>Subscribe</span>
          </a>
        </li> -->
        <li class="i18n">
          <!-- <span class="a">{{$t('sidebar.language')}}</span> -->
          <a class="a" target="_bland" href="http://www.uniceramics.com.cn">
            <span>中文</span>
          </a>
        </li>

      </ul>
      
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props:{
      title:{type:String,default:''}
    },
    data() {
        return {
            isActive:false,
            hoverIndex:'',
            showRouter:[],
            subNavShowIndex:'',
            subMenuHeight:0
        }
    },
    created(){
      const routes = this.routes
      let showRouter = [];
      this.routes.forEach((item)=>{
        if(!!!item.hidden){
          showRouter.push(item)
        }
      })
      this.showRouter=showRouter;
      
    },
    computed: {
      routes() {
        return this.$router.options.routes
      },
      //根据二级标签长度计算二级导航高度
      subMenuLength(){
        return (arr)=>{
          let num = 0;
          arr.forEach((item)=>{
            !item.hidden&&num++; //过滤隐藏页面
          })
          return num;
        }
      },
      lang(){return this.$store.state.index.lang}
    },
    methods:{
      openNav(){
        this.isActive = !this.isActive;
      },
      closeNav(title){
        this.isActive = false;
        this.title=title;
      },
      openSubmenu(index){
        if(this.subNavShowIndex===index){
          this.subNavShowIndex='';
        }else{
          this.subNavShowIndex=index;
        }
      },
      tips(){
        // this.$message('暂未开放，敬请期待！');
      },
      changeLang(){
        let locale = localStorage.getItem('locale');
        let n = ''
        if(locale==='zh'){
          n = 'en'
          this.$store.commit('index/setLang','en');
        }else{
          n = 'zh'
          this.$store.commit('index/setLang','zh');
        }
        this.$i18n.locale = n;  //修改i18n的locale值，
        localStorage.setItem('locale',n);  //存入本地的locale值
        this.$router.go(0);
      }
      // async logout() {
      //   await this.$store.dispatch('user/logout')
      //   this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      // }
    }
}
</script>

<style scoped>
header{display:none;}

@media (max-width: 991px){
header{display:block; height: 55px; position: fixed;width: 100%; top: 0;left: 0; z-index: 3000;}
header .logo-wrap{height: 55px; display:flex; justify-content: space-between; align-items: center; position: relative; z-index: 10; background:rgba(255,255,255,0.95); padding:0 5px; box-shadow: 0 0 6px 0 #bec5cc; font-size:16px;}
header .logo-wrap .logo{position: relative; z-index:10;}
header .logo-wrap .logo img{width:45px; height:45px;}
header .logo-wrap .title{height:55px; line-height:55px; position: absolute; z-index:9; left:0; right:0; text-align:center;}


.menu-button {width: 32px; height: 22px;;cursor: pointer; position: relative; z-index:10;}
.menu-button .bar { position: absolute; width: 100%; height: 2px; left: 0; background: #d70e19; -webkit-transition: all .5s;transition: all .5s;}
.menu-button .bar:first-child { top: 0;}
.menu-button .bar:nth-child(2){top: calc(50% - 1px);}
.menu-button .bar:nth-child(3){ bottom: 0;}
.menu-button.active .bar:first-child {top: 50%; transform: rotate(45deg) translateY(-70%);}
.menu-button.active .bar:nth-child(2) {opacity: 0;}
.menu-button.active .bar:nth-child(3) {bottom: 50%; transform: rotate(-45deg) translateY(80%);}


.nav-wrap{position: absolute; z-index: 9;width: 100%; height: calc(100vh - 55px);top:100%;left:0; overflow-y: auto; visibility: hidden; background:rgba(255,255,255,0); transition-duration: 300ms;}
.nav-wrap ul.nav{transform: translate3d(0,-100%,0); transition-duration: 500ms; background:#fff;}
.nav-wrap ul.nav>li:nth-of-type(1){padding-top:20px;}
.nav-wrap ul.nav>li>.a{display: block; height:50px; line-height:50px;text-align:center; font-size:18px; color:#111; font-weight:300; border-bottom: 0.5px solid #eee}
.nav-wrap ul.nav>li>.a.router-link-active{color:#d70e19;}
.nav-wrap ul.nav>li>.a i{transition-duration: 300ms; margin-left:5px;}
.nav-wrap ul.nav>li>.a.show i{transform: rotate(90deg);}
.nav-wrap .sub-nav{background:#f6f6f6;  overflow: hidden; transition-duration: 300ms;} 
.nav-wrap .sub-nav.hide{height:0!important;}
.nav-wrap .sub-nav>li>.a{display:block; height:45px; line-height:45px;text-align:center; font-size:16px; color:#666;}
.nav-wrap .sub-nav>li>a.router-link-active{color:#d70e19;}


header.active .nav-wrap{background:rgba(255,255,255,.99); visibility: visible;}
header.active .nav-wrap .nav{transform: translate3d(0,0,0);}

/*英文版新闻模块和中文版不一致，针对不同版本显示隐藏*/
.nav-wrap.en ul>li:nth-of-type(3){display: none;}
.nav-wrap.zh ul>li:nth-of-type(4){display: none;}
}
</style>

